import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'smart-fix-bedrock-chat-header',
  templateUrl: './bedrock-chat-header.component.html',
  styleUrls: ['./bedrock-chat-header.component.scss'],
})
export class BedrockChatHeaderComponent {
  @Output() endChat = new EventEmitter<void>();
  @Input() isFeedback: boolean = false;

  onEndChat() {
    this.endChat.emit();
  }
}
